class ProductsSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          /* Related products slider */
          const slider = this.querySelector('.related-slider__list');
          const prevBtn = this.querySelector('.related-slider__button-prev');
          const nextBtn = this.querySelector('.related-slider__button-next');
          const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
          const numberOfSlidesDesktop = this.getAttribute('data-slides-desktop');
          const numberOfSlidesTablet = this.getAttribute('data-slides-tablet');
          const numberOfSlidesMobile = this.getAttribute('data-slides-mobile');
          
          if (twoColumns && document.querySelector('.related-slider__list')) {
            const productSlider = new Swiper(slider, {
              slidesPerView: numberOfSlidesMobile || 2,
              spaceBetween: 10,
              navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
              },
              breakpoints: {
                750: {
                  slidesPerView: numberOfSlidesTablet || 3,
                },
                1200: {
                  slidesPerView: numberOfSlidesDesktop || 4,
                },
              },
            });
          } else if (document.querySelector('.related-slider__list')) {
            const productSlider = new Swiper(slider, {
              slidesPerView: numberOfSlidesMobile || 1,
              spaceBetween: 10,
              navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
              },
              breakpoints: {
                750: {
                  slidesPerView: numberOfSlidesTablet || 2,
                },
                1200: {
                  slidesPerView: numberOfSlidesDesktop || 3,
                },
              },
            });
          }

      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
}

// on document ready
document.addEventListener('DOMContentLoaded', () => {
  customElements.define('products-slider', ProductsSlider);
});
